import { MAX_CATEGORY_NAME_LENGTH } from '@repo/api-contracts';
import type { FormEvent, ReactElement } from 'react';
import { Button, Input } from '@/shared/ui';

interface AddChildFormProps {
  readonly value: string;
  readonly isPending: boolean;
  readonly onChange: (value: string) => void;
  readonly onSubmit: () => void;
}

/** 소분류 인라인 추가 폼 — 상태는 목록 소유자가 갖는 컨트롤드 폼. */
export const AddChildForm = ({
  value,
  isPending,
  onChange,
  onSubmit,
}: AddChildFormProps): ReactElement => {
  const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit} className="flex items-center gap-1.5">
      <Input
        className="h-8 w-36"
        placeholder="새 소분류 이름"
        value={value}
        maxLength={MAX_CATEGORY_NAME_LENGTH}
        onChange={(event) => onChange(event.target.value)}
      />
      <Button type="submit" variant="outline" size="sm" isLoading={isPending}>
        소분류 추가
      </Button>
    </form>
  );
};
